import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';
import './personal.css';

let storedTheme = null;
try {
  storedTheme = localStorage.getItem('theme');
} catch {
  // Reading the site does not require browser storage.
}
const systemTheme = window.matchMedia?.('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
document.documentElement.setAttribute(
  'data-theme',
  storedTheme === 'dark' || storedTheme === 'light' ? storedTheme : systemTheme
);

ReactDOM.render(
  <BrowserRouter><App /></BrowserRouter>,
  document.getElementById('root')
);
